import styled from 'styled-components';
import 'bootstrap/dist/css/bootstrap.min.css';

export const Spacer = styled.div`
  height: 15rem;
  background: #fcd3d3;


  @media (max-width: 425px) {
    height: 8rem; 
  }
`;
